import {ProtocolMenuItem} from "../ProtocolMenuItem";
import {protocolStepsData} from "../../../RiskProfiling/components/servicesV2/mock_protocol";
import {FINAL_STEP_UID} from "../../../RiskProfiling/constants";

export class TradingProtocolDataServiceV2 extends ProtocolMenuItem {
  constructor(uid, name, customer_id, getPrevStepAnswer, handleCreateOrderClick, handleValidateOrderClick, validateMissingData) {
    super(uid, name, customer_id, getPrevStepAnswer, handleCreateOrderClick);
    this._createAccountStep = 'not-existing-uid'; // TODO: not used in new design
    this._validateAccountFunc = handleValidateOrderClick;
    this._validateAccountStep = FINAL_STEP_UID;
    this.__stepsData = protocolStepsData;
    this.__is_new_design = true;
    this._validateMissingData = validateMissingData;
  }
}